import React from 'react';
import { Field } from 'formik';
import Section from '../form/Section';
import Checkbox from '../form/Checkbox';

const TermsConditions = ({ values }) => {
  return (
    <Section title='Terms and Conditions'>
      <ul>
        <li className='mb-3'>
          If accepted by the respective programme's Admissions Committee, NUS
          requires pre-payment by credit card or bank transfer
        </li>
        <li className='mb-3'>
          <div className='mb-3'>
            NUS must be notified in writing of all cancellations and transfers.
            If you are admitted to a programme, but find that you are unable to
            attend, you have the following cancellation options:
          </div>
          <div className='mb-3 font-semibold'>
            Cancellation / Postponement charge:
          </div>
          <ul>
            <li className='mb-3'>
              &lt; 45 days before programme: 50% of applicable programme fee
            </li>
            <li className='mb-3'>
              &lt; 15 days before programme: 100% of applicable programme fee
            </li>
          </ul>
        </li>
        <li className='mb-3'>
          NUS reserves the right to postpone or cancel a course by giving at
          least 14 days’ notice.
        </li>
      </ul>
      <p className='mb-3'>
        Fees stated are net of taxes. All applicable taxes (if any) shall be
        borne by the applicant.
      </p>
      <p className='mb-3'>
        By filling up this registration form, I hereby agree and consent that my
        personal data provided in this form may be collected, used, processed
        and disclosed by NUS for the purposes of processing my registration, as
        well as other purposes stating in this notice, in accordance with the
        Personal Data Protection Act 2012 and all subsidiary legislation related
        thereto. In respect of disclosure, I understand that NUS may disclose my
        personal data to third parties (which may be in or outside of Singapore)
        where necessary for the above-stated purposes.
      </p>
      <div className='mb-2'>
        <Field
          label='Yes, add me to your mailing list.'
          name='mailing_list'
          value={values.mailing_list}
          component={Checkbox}
        />
      </div>
    </Section>
  );
};

export default TermsConditions;
